import './Type.css';
import typeFacesHeader from '../../assets/images/typeFacesHeader.png'
import typefaces from '../../assets/constants/typefaces'
import {Link} from 'react-router-dom'
import React from "react";
import Footer from '../Footer';

function Type(props) {

    return (
        <div className="type">
            <Link className="link" to="/" >
                <p className="backButton"> back to home </p>
            </Link>
            <h1 className="typeHeaderText"> Type </h1>
            <img className="typeFacesHeader" src={typeFacesHeader} alt="faces by cerasus, with two purple shimmering butterflies" />
            {typefaces.map((typeface, index) => (
                <div className="typefaceRectangleDiv">
                    <Link to={"/typeface/" + typeface.pageName}>
                        <img src={typeface.src} alt={typeface.alt} className="typefaceRectangle" />
                    </Link>
                </div>
            ))}
            <Footer/>
        </div>

    )

}

export default Type;